import { render, staticRenderFns } from "./MultiImg.vue?vue&type=template&id=3618449a&scoped=true&"
import script from "./MultiImg.vue?vue&type=script&lang=js&"
export * from "./MultiImg.vue?vue&type=script&lang=js&"
import style0 from "./MultiImg.vue?vue&type=style&index=0&id=3618449a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618449a",
  null
  
)

export default component.exports